import apiClient from './apiClient'

export const deleteSubCustomerMarkUps = async () => await apiClient.delete('/api/SubCustomerMarkUps')
export const getSubCustomerMarkUps = async (subCustomerId='') => await apiClient.get(`/api/SubCustomerMarkUps/${subCustomerId}`)
export const postSubCustomerMarkUps = async (payload) => await apiClient.post('/api/SubCustomerMarkUps', payload)
export const putSubCustomerMarkUps = async (payload) => await apiClient.put('/api/SubCustomerMarkUps', payload)
